import { API_DOMAIN } from '@constants';
import type { PVTaskRequestData, PVTaskRespData } from '@types';
import { teamConfig } from '@utils/teamConfig';
import axios from '@utils/axios';

/** 创建素材上传任务 */
export function taskCreateApi(data: PVTaskRequestData) {
  const url = teamConfig(
    `${API_DOMAIN}/upload/videos/task`,
    `${API_DOMAIN}/team/app/tours/upload/videos/task`
  );
  return axios.post<PVTaskRespData>(url, data);
}

/** 素材上传完成后调用转码 */
export function taskStartApi(id: number) {
  const url = teamConfig(
    `${API_DOMAIN}/upload/videos/task/${id}`,
    `${API_DOMAIN}/team/app/tours/upload/videos/task/${id}`
  );
  return axios.post(url, { status: 3 });
}
